import React, {useEffect, useState} from "react";

import CommentsService from "../../services/comments.service";
import ReactQuill from "react-quill";
import {Alert, Button, Col, Form, Modal, Row} from "react-bootstrap";
import {addParam, isLoggedIn} from "../../common/utils";
import {useForm} from "react-hook-form";
import {Link, useSearchParams} from "react-router-dom";
import AuthService from "../../services/auth.service";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";

const ContactEntity = ({entityId, entityType, entityName}) => {

    const [searchParams, setSearchParams] = useSearchParams();  // eslint-disable-line no-unused-vars

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    // confirm modal
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [messageData, setMessageData] = useState(null);
    const handleCloseConfirmModal = () => setShowConfirmModal(false);
    const handleShowConfirmModal = (data) => {
        setShowConfirmModal(true);
        setMessageData(data);
    }

    // result modal
    const [showResultModal, setShowResultModal] = useState(searchParams.get("result") === "success");
    const handleCloseResultModal = () => {
        setShowResultModal(false);
        if (entityType === 'venue') {
            window.location.assign("/venues");
        } else {
            window.location.assign("/acts");
        }
    }

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
    } = useForm()

    const reactQuillRef = React.useRef();

    // limit to 1500 characters
    const checkCharacterCount = (event) => {
        const unprivilegedEditor = reactQuillRef.current.unprivilegedEditor;
        if (unprivilegedEditor.getLength() > 1500 && event.key !== 'Backspace') {
            // event.preventDefault();
            window.alert("You've reached the maximum character count of 1500.")
        }
    };

    const onEditorStateChange = (editorState) => {
        // disabling matchVisual did not work: https://stackoverflow.com/questions/43748108/how-to-keep-quill-from-inserting-blank-paragraphs-pbr-p-before-heading
        if (editorState === "<p><br></p>") {
            editorState = ""
        }
        setValue("contactMessage", editorState);
    };

    // cannot register contactMessage like the other fields because the input type is react-quill
    useEffect(() => {
        register("contactMessage", {required: true});
    }, [register]);  // eslint-disable-line react-hooks/exhaustive-deps

    const handleSubmitRHF = () => {
        // console.log("saving entity contact: " + JSON.stringify(data));
        let payload = {
            message: messageData.contactMessage,
            entity_id: entityId,
            entity_type: entityType,
            entity_name: entityName,
        }
        console.log("payload: " + JSON.stringify(payload))

        CommentsService.createComment(payload).then(
            response => {
                console.log("saved comment:" + JSON.stringify(response.data));
                window.location.href = addParam(new URL(window.location.href), "result", "success");
            },
            error => {
                console.log(error);
            });
    }

    return (
        <>
            {loggedIn &&
                <>
                    {!editsAllowed &&
                        <Alert variant="danger">
                            Registration is closed for Porchfest 2025. If you need to reach a performer or venue,
                            please <Link to="/contact" reloadDocument="true">contact us</Link>.
                        </Alert>
                    }
                    {/*<Row><Col><strong>Contact</strong></Col></Row>*/}
                    {/*"handleSubmit" will validate your inputs before invoking the next function*/}
                    <Form onSubmit={handleSubmit(handleShowConfirmModal)}>
                        <Row>
                            <Col>
                                {entityType === 'venue' &&
                                    <>
                                        <p>
                                            Use the box below to contact the owner of "{entityName}" and inquire about
                                            the possibility of hosting your act with them (if you're a performer).
                                        </p>
                                        <p>
                                            Once submitted, we'll promptly notify the owner via email. From there, you
                                            can continue your conversation directly through email.
                                        </p>
                                    </>
                                }
                                {entityType === 'act' &&
                                    <>
                                        <p>
                                            Use the box below to contact the owner of "{entityName}" and inquire about
                                            the possibility of hosting them (if you're a host).
                                        </p>
                                        <p>
                                            Once submitted, we'll promptly notify the owner via email. From there, you
                                            can continue your conversation directly through email.
                                        </p>
                                    </>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <ReactQuill theme="snow"
                                            onChange={onEditorStateChange}
                                            modules={{
                                                toolbar: [
                                                    // [{ 'header': [1, 2, false] }],
                                                    ['bold', 'italic', 'underline'],
                                                    [{'list': 'ordered'}, {'list': 'bullet'}],
                                                    ['link'],
                                                    ['clean']
                                                ],
                                                // this is needed to eliminate the <p><br></p> problem
                                                clipboard: {
                                                    matchVisual: false
                                                }
                                            }}
                                    // placeholder={"Mention your name, your act of venue description, and the reason you're contacting with "}
                                            onKeyDown={checkCharacterCount}
                                            ref={reactQuillRef}
                                />
                                {errors.contactMessage &&
                                    <span className="pf-validation-error">This field is required</span>}
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>
                                <Button type="submit" disabled={!editsAllowed}>Send message</Button>
                            </Col>
                        </Row>
                    </Form>

                    <Modal show={showConfirmModal} onHide={handleCloseConfirmModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Send Message?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to send this message to "{entityName}"?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={handleSubmitRHF}>
                                Send it
                            </Button>
                            <Button variant="outline-secondary" onClick={handleCloseConfirmModal}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showResultModal} onHide={handleCloseResultModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Message Sent</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Your message was successfully sent to "{entityName}" via email. <br/><br/>
                            Click the OK button below to go back to the {entityType} list.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseResultModal}>
                                OK
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </>
            }
        </>
    );
};

export default ContactEntity;
